import { MouseEvent } from 'react';
import { SearchItemViewModel } from '@/types/api';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { EasyAccess } from '@/features/tag';
import { useUserToken } from '@/features/user-token-provider/use-user-token';
import { sendCardDataClickEvent } from '@/utils/send-card-data-click-event';
interface Props {
  items: SearchItemViewModel[] | null;
  title: string;
  dataTest: string;
  handleClickItem: (e: MouseEvent, href: string) => void;
}
function SearchResultChips({
  items,
  title,
  dataTest,
  handleClickItem
}: Props) {
  const {
    userToken
  } = useUserToken();
  const {
    isMobile
  } = useMobileDetect();
  if (!items?.length) return;
  const handleClick = (e: MouseEvent, item: SearchItemViewModel, href: string) => {
    if (item.queryId) sendCardDataClickEvent({
      userToken: userToken ?? '',
      id: item.id,
      queryId: item.queryId,
      type: item.type ?? null,
      position: item.position ?? null
    });
    handleClickItem(e, href);
  };
  return <div className='mb-5 flex w-full flex-col gap-2 text-text-black lg:px-1' data-sentry-component="SearchResultChips" data-sentry-source-file="search-result-chips.tsx">
            <span className='text-sm font-medium'>{title}</span>
            <div data-test={`search-result--${dataTest}`} className='flex flex-wrap items-center gap-1 text-text-black'>
                {items.map(item => {
        const itemHref = getSearchResultItemURL(item);
        return <EasyAccess key={item.id} size={isMobile ? 'medium' : 'large'} className='w-fit justify-center whitespace-nowrap border-border-gray-light bg-white' href={itemHref} iconCloseClassName='hidden' onClick={e => handleClick(e, item, itemHref)}>
                            <span>{item.nameFa}</span>
                        </EasyAccess>;
      })}
            </div>
        </div>;
}
export default SearchResultChips;